import React, { useEffect } from "react";
import { Combobox, Toast, AddGuest } from "../..";
import { useState } from "react";
import { apis, get } from "../../../Utils/axios";
import EmployeeInfo from "../../Cards/EmployeeInfo";
import { TbUsers } from "react-icons/tb";

function TravellerSearch({
	onSelect = () => {},
	placeholder = "Search Users and Guests",
	label,
	selected = {},
	mandatoryField = {},
	searchOnly = false,
	className = "",
	prefetch = true,
}) {
	const [AllTravellers, setAllTravellers] = useState([]);
	const [Loader, setLoader] = useState();

	const fetchTravellers = (query) => {
		setLoader(true);
		const params = { page: 1 };
		if (query) {
			params.search = query;
		}

		get(apis.searchTravellers, params, (r, e) => {
			if (r) {
				setAllTravellers(r.travellers);
				setLoader(false);
			} else if (e) {
				console.log(e);
				Toast.handleError(e);
				setLoader(false);
			}
		});
	};

	const onChange = (query) => {
		fetchTravellers(query);
	};

	useEffect(() => {
		if (prefetch) {
			fetchTravellers("");
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [prefetch]);

	return (
		<div className="flex flex-col items-stretch w-full gap-2 sm:flex-row sm:items-end">
			<Combobox
				loading={Loader}
				label={label}
				placeholder={placeholder}
				className={`w-full ${className}`}
				onChange={onChange}
				options={AllTravellers.map((user) => ({
					...user,
					label: `${user.fName} ${user.lName}`,
					value: user.id,
				}))}
				selected={selected}
				onSelect={onSelect}
				renderItem={(traveller, i) => (
					<li className="!p-0 hover:bg-light flex-center-between">
						<EmployeeInfo className="w-full" key={i} employee={traveller} />
						<div className="px-4">
							{traveller.team && (
								<div className="gap-2 align-center">
									<TbUsers /> <div className="whitespace-nowrap text-label">{traveller.team?.name} Team</div>
								</div>
							)}
							{traveller.isGuest && <div className="text-label">Guest</div>}
						</div>
					</li>
				)}
			/>
			{!searchOnly && <AddGuest mandatoryField={mandatoryField} btnLabel="+ Add Guest" btnVariant="outlined" btnClass="w-full sm:w-auto btn-sm" />}
		</div>
	);
}

export default TravellerSearch;
